import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24.000000",
  height: "24.000000",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("desc", null, "Created with Pixso.", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip85_2627" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      id: "search",
      width: "24.000000",
      height: "24.000000",
      fill: "white",
      "fill-opacity": "0"
    })
  ])
], -1)
const _hoisted_4 = { "clip-path": "url(#clip85_2627)" }
const _hoisted_5 = ["fill"]
const _hoisted_6 = ["fill"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("g", _hoisted_4, [
        _createElementVNode("path", {
          id: "path",
          d: "M9.56 18.82C9.37 18.82 9.18 18.75 9.03 18.6L2.96 12.53C2.67 12.24 2.67 11.76 2.96 11.47L9.03 5.4C9.32 5.11 9.8 5.11 10.09 5.4C10.38 5.69 10.38 6.17 10.09 6.46L4.55 12L10.09 17.54C10.38 17.83 10.38 18.31 10.09 18.6C9.95 18.75 9.75 18.82 9.56 18.82L9.56 18.82Z",
          fill: _ctx.color,
          "fill-opacity": "1.000000",
          "fill-rule": "nonzero"
        }, null, 8, _hoisted_5),
        _createElementVNode("path", {
          id: "path",
          d: "M20.49 12.75L3.66 12.75C3.25 12.75 2.91 12.4 2.91 12C2.91 11.59 3.25 11.25 3.66 11.25L20.49 11.25C20.9 11.25 21.24 11.59 21.24 12C21.24 12.4 20.9 12.75 20.49 12.75L20.49 12.75Z",
          fill: _ctx.color,
          "fill-opacity": "1.000000",
          "fill-rule": "nonzero"
        }, null, 8, _hoisted_6)
      ])
    ]))
  ]))
}